import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import SkeletonTable from './SkeletonTable'

export default function SkeletonWebhook() {
    return (
        <Grid container spacing={2} size={12}>
            <Grid size={12}>
                <Paper sx={{ p: 3 }}>
                    <Grid container spacing={4}>
                        <Grid size={{ xs: 12, md: 7 }}>
                            <Stack direction="row" spacing={2} sx={{ alignItems: 'baseline' }}>
                                <Skeleton variant="text" width={120} sx={{ fontSize: '1.5rem' }} />
                                <Skeleton variant="text" width={180} />
                            </Stack>
                            <Stack direction="row" spacing={4} sx={{ alignItems: 'center', mt: 2 }}>
                                <Skeleton variant="circular" width={140} height={140} />
                                <Stack spacing={1.5}>
                                    {Array.from({ length: 3 }, (_, index) => (
                                        <Stack
                                            key={index}
                                            direction="row"
                                            spacing={1.5}
                                            sx={{ alignItems: 'center' }}
                                        >
                                            <Skeleton variant="circular" width={14} height={14} />
                                            <Skeleton variant="text" width={80} />
                                        </Stack>
                                    ))}
                                </Stack>
                            </Stack>
                        </Grid>

                        <Grid size={{ xs: 12, md: 5 }}>
                            <Stack spacing={1.5}>
                                <Skeleton variant="rounded" width={110} height={40} />
                                <Skeleton variant="text" width={180} sx={{ fontSize: '1.25rem' }} />
                                <Skeleton variant="text" width="80%" />
                                <Skeleton variant="text" width="70%" />
                            </Stack>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>

            <Grid size={12}>
                <Paper variant="outlined">
                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                            px: 2,
                            py: 1.5,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Skeleton variant="text" width={110} sx={{ fontSize: '1.25rem' }} />
                        <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                            <Skeleton variant="rounded" width={120} height={24} />
                            {Array.from({ length: 3 }, (_, index) => (
                                <Skeleton key={index} variant="circular" width={22} height={22} />
                            ))}
                        </Stack>
                    </Stack>

                    <Box>
                        <SkeletonTable rows={14} columns={6} showToolbar={false} />
                    </Box>

                    <Stack
                        direction="row"
                        spacing={1.5}
                        sx={{ px: 2, py: 1.5, justifyContent: 'flex-end', alignItems: 'center' }}
                    >
                        <Skeleton variant="text" width={90} />
                        <Skeleton variant="circular" width={22} height={22} />
                        <Skeleton variant="circular" width={22} height={22} />
                    </Stack>
                </Paper>
            </Grid>
        </Grid>
    )
}
